import { useParams } from 'react-router-dom';

import { Loader } from 'components/Loader';
import { DataTable } from 'components/DataTable';
import { useGetDetailedTotemsOfOrganizationQuery, TotemState } from 'data/__generated__';

import { CreateTotemButton } from './CreateTotemButton';
import {
    organizationTotemsColumns,
    type OrganizationTotemRow,
    type OrganizationTotemFilterInput,
} from './constants/totemsColumns';

type ParamTypes = {
    organizationId: string;
};

const defaultFilters: OrganizationTotemFilterInput = {
    searchValue: '',
    state: [TotemState.Rollout],
};

export const TotemsDetails = () => {
    const { organizationId = '' } = useParams<ParamTypes>();

    const {
        loading: totemsLoading,
        error: totemsError,
        data: totemsData,
        refetch: refetchTotems,
    } = useGetDetailedTotemsOfOrganizationQuery({
        variables: { organizationId },
    });

    if (totemsLoading) {
        return (
            <div className="flex min-h-[200px] w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (totemsError || !totemsData) {
        throw new Error('Une erreur est survenue lors de la récupération des totems');
    }

    const totems = totemsData.totemsOfOrganization;
    // Grow with the number of totems (rare to have many per org) but cap to keep the section compact.
    const tableHeight = Math.min(600, 200 + totems.length * 48);

    return (
        <div style={{ height: tableHeight }} className="flex w-full flex-col overflow-hidden">
            <DataTable<OrganizationTotemRow, OrganizationTotemFilterInput>
                columns={organizationTotemsColumns}
                data={totems}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/totem/${row._id}`}
                defaultFilters={defaultFilters}
                searchPlaceholder="Nom, numéro, adresse, admin…"
                searchFilterKey="searchValue"
                autoFocusSearch={false}
                disableUrlSync
                emptyMessage="Aucun totem"
                toolbarActions={
                    <CreateTotemButton
                        organizationId={organizationId}
                        refetchTotems={() => {
                            void refetchTotems();
                        }}
                    />
                }
            />
        </div>
    );
};
